/* eslint-disable import/prefer-default-export */

export const decodeId = (id, type) =>
  parseInt(decodeURIComponent(id).split(`gid://shopify/${type}/`)[1], 10);

export const getParamFromUrl = (parameterName) => {
  let result = null;
  let tmp = [];
  window.location.search
    .substr(1)
    .split('&')
    .forEach((item) => {
      tmp = item.split('=');
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
  return result;
};

export const getShopUrl = () => {
  const technicalDataEl = document.querySelector('[data-technical]');
  if (!technicalDataEl) {
    // eslint-disable-next-line no-console
    console.error(
      'utils/storefront/index.js: Could not locate Storefront credentials',
    );
  }

  const technicalData = JSON.parse(technicalDataEl.textContent);
  return technicalData.shopName;
};

export const generateUrl = (handle, type) => {
  if (!handle) return null;
  const shopUrl = getShopUrl();
  return `https://${shopUrl}/${type}/${handle}`;
};

export const isLauraCanada = () => {
  const technicalDataEl = document.querySelector('[data-technical]');
  if (!technicalDataEl) {
    // eslint-disable-next-line no-console
    console.error(
      'utils/storefront/index.js: Could not locate Storefront credentials',
    );
  }

  const technicalData = JSON.parse(technicalDataEl.textContent);
  return technicalData.shopName?.includes('laura');
};

export const isMelanieLyne = () => {
  const technicalDataEl = document.querySelector('[data-technical]');
  if (!technicalDataEl) {
    // eslint-disable-next-line no-console
    console.error(
      'utils/storefront/index.js: Could not locate Storefront credentials',
    );
  }

  const technicalData = JSON.parse(technicalDataEl.textContent);
  return technicalData.shopName?.includes('melanie');
};

export const isFirstPage = () => {
  const url = new URL(window.location.href);
  const urlParams = new URLSearchParams(url.search);
  const pageParam = urlParams.get('page');
  return !pageParam || pageParam === '1';
};

export const validatePhoneNumber = (v) =>
  v.length === 10 &&
  // eslint-disable-next-line no-useless-escape
  /^[-\s\./0-9]*$/g.test(v);

export const getStoreState = (location) => {
  const locale = `${Shopify.locale}-${Shopify.country}`;

  const days = [0, 1, 2, 3, 4, 5, 6].map((day, i) =>
    // The first day of 2023 was a Sunday so we use that as a static base
    new Date(`2023-01-0${i + 1}T00:00:00`).toLocaleDateString(locale, {
      weekday: 'long',
    }),
  );

  const d = new Date();
  const currentDay = d.getDay();
  const currentMinute = d.getHours() * 60 + d.getMinutes();
  const { hours } = location;

  // Find the next day the store will be open
  let nextOpenDay = currentDay < 6 ? currentDay + 1 : 0;
  for (let i = 0; i < 7; i += 1) {
    if (hours[nextOpenDay].isOpen) {
      break;
    } else {
      nextOpenDay = nextOpenDay < 6 ? nextOpenDay + 1 : 0;
    }
  }

  const todaysHours = hours[currentDay];
  const [open, close] = todaysHours.displayHours.split(' - ');
  const nextOpenDayOfWeek = days[nextOpenDay];
  const nextOpenTime = hours[nextOpenDay].displayHours.split(' - ')[0];

  // Not open today, show when store next opens
  if (!todaysHours.isOpen || currentMinute >= todaysHours.closeMinute) {
    return {
      openNow: false,
      openToday: todaysHours.isOpen,
      summary: window.TMW.Strings.storeLocator.closedNow
        .replace('{{day}}', nextOpenDayOfWeek)
        .replace('{{time}}', nextOpenTime),
    };
  }
  // Store is open today, but not yet
  if (currentMinute < todaysHours.openMinute) {
    return {
      openNow: false,
      openToday: todaysHours.isOpen,
      summary: window.TMW.Strings.storeLocator.openAt.replace('{{time}}', open),
    };
  }
  // Store is open now
  return {
    openNow: true,
    openToday: todaysHours.isOpen,
    summary: window.TMW.Strings.storeLocator.openNow.replace('{{time}}', close),
  };
};

export const validateEmail = (email) =>
  // eslint-disable-next-line no-useless-escape, max-len
  /^[a-zA-Z0-9!#$%&\'*+\\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&\'*+\\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(
    email,
  );

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

export const setCookie = (name, value, days = 1) => {
  const expire = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value}; expires=${expire}; path=/`;
};

export const sortProductFits = (fits) => {
  if (!fits) return [];
  return fits.sort((a, b) => {
    const order = { Laura: 0, Plus: 1, Petites: 2 };
    return order[a] - order[b];
  });
};

export const sortProductSizes = (sizes) => {
  let sortedSizes = [];
  const windowSizesOrder = window.TMW.Strings.product.sizesOrder.split(', ');
  windowSizesOrder.map((size) => size.trim().toLowerCase());

  // Sort sizes array based on the sort order defined in windowSizesOrder
  sortedSizes = sizes.sort((a, b) => {
    const indexA = windowSizesOrder.indexOf(a.trim().toLowerCase());
    const indexB = windowSizesOrder.indexOf(b.trim().toLowerCase());
    return indexA - indexB;
  });

  return sortedSizes;
};

export const getProductLabel = (tags = []) => {
  if (tags.includes('final-sale::true')) {
    return window.TMW.Strings.product.finalSale;
  }
  if (tags.includes('exchange-only::true')) {
    return window.TMW.Strings.product.exchangeOnly;
  }
  return null;
};

export const getProductFit = (product = {}) =>
  product.variants?.[0].selectedOptions?.find(
    (option) =>
      option.name.trim().toLowerCase() ===
      window.TMW.Strings.product.options.fit,
  )?.value || null;

export const getProductColor = (product = {}) =>
  getVariantColor(product.variants?.[0]);

export const getVariantColor = (variant = {}) =>
  variant.selectedOptions?.find(
    (option) =>
      option.name.trim().toLowerCase() ===
      window.TMW.Strings.product.options.color,
  )?.value || null;

export const waitForElm = (selector, root) =>
  new Promise((resolve) => {
    if (document.querySelector(selector)) {
      resolve(document.querySelector(selector));
      return;
    }

    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });
    observer.observe(root || document.body, {
      childList: true,
      subtree: true,
    });
  });
